"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var crypt_1 = require("./crypt");

var event_1 = require("./event");

var config_1 = require("./config");

var Utils =
/** @class */
function () {
  function Utils() {}

  Utils.patchCookie = function (execute) {
    if (execute && Utils.isClient()) {
      var d = new Date(0);
      document.cookie = Utils.COOKIE_ID_KEY + "=" + Math.random() + ";path=/;expires=" + d.toUTCString() + ";";
    }
  };

  Utils.refreshCookieIfExists = function (cookieName, expires) {
    var c = Utils.getCookie(cookieName);

    if (c) {
      this.setCookie(cookieName, c, expires);
    }
  };

  Utils.processDiveParameters = function (allParameters, expires) {
    if (Utils.isClient()) {
      Object.entries(allParameters).forEach(function (_a) {
        var key = _a[0],
            value = _a[1];

        if (key.indexOf(Utils.PARAMETER_PREFIX) !== -1) {
          // If cookie dive_cid was set by using SetDiveCid, must not be stepped on. The priority is SetDiveCid method
          if (key !== Utils.DIVE_CID_KEY || key === Utils.DIVE_CID_KEY && !Utils.getCookie(Utils.DIVE_CID_KEY)) {
            Utils.setCookie(key, value, expires);
          }
        }
      });
    }
  };

  Utils.refreshAllDiveCookies = function (expires) {
    var diveCookies = Utils.getAllDiveCookies();
    Object.entries(diveCookies).forEach(function (_a) {
      var key = _a[0],
          value = _a[1];
      Utils.setCookie(key, value, expires);
    });
  };

  Utils.getAllDiveCookies = function () {
    var cookies = {};

    if (Utils.isClient()) {
      var pairs = document.cookie.split(";");

      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split("=");

        if (pair[0].indexOf(Utils.PARAMETER_PREFIX) !== -1) {
          cookies[(pair[0] + '').trim()] = unescape(pair.slice(1).join('='));
        }
      }
    }

    return cookies;
  };

  Utils.processQueryStringParams = function (sessionLifeTime) {
    if (Utils.isClient()) {
      var parameters = Utils.getQueryStringParams(window.location.search);
      var referrerQueryString = Utils.getReferrerQueryString();

      if (referrerQueryString) {
        parameters = Object.assign(Utils.getQueryStringParams(referrerQueryString), parameters);
      }

      Utils.processDiveParameters(parameters, sessionLifeTime);
    }
  };

  Utils.getReferrerQueryString = function () {
    var ret = null;

    if (Utils.isClient() && document.referrer) {
      var referrerArr = document.referrer.split("?");

      if (referrerArr.length > 1) {
        ret = referrerArr[1];
      }
    }

    return ret;
  };

  Utils.uuidv4 = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c === 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  };

  Utils.getDeviceId = function () {
    var cookie;

    if (!(cookie = Utils.getCookie(Utils.COOKIE_ID_KEY))) {
      Utils.setCookie(Utils.COOKIE_ID_KEY, cookie = Utils.uuidv4(), 0);
    }

    return cookie;
  };

  Utils.paramsToObject = function (params) {
    var _a;

    var arrParams = params.split("=");

    if (arrParams[0]) {
      if (arrParams[0].startsWith("dive_")) event_1.default.SetCustomHeaderParam(arrParams[0], arrParams[1]);
      return _a = {}, _a[arrParams[0]] = arrParams[1] || null, _a;
    }

    return {};
  };

  Utils.getQueryStringParams = function (locationSearch) {
    var search = locationSearch.replace("\?", "");
    var params = search.split("&");
    return params.map(this.paramsToObject).reduce(function (obj, item) {
      return obj ? Object.assign(obj, item) : {};
    });
  };

  Utils.digest = function (event, key) {
    return crypt_1.default.sha1_hmac(event, key);
  };

  Utils.firstSession = function () {
    if (!this.isClient()) return true;
    return !this.getCookie(Utils.SESSION_ID_KEY);
  };

  Utils.setClientSessionIdCookie = function (sessionLifeTime) {
    var sessionId = Utils.getCookie(Utils.SESSION_ID_KEY);
    if (!sessionId) sessionId = Utils.uuidv4();
    this.setCookie(Utils.SESSION_ID_KEY, sessionId, sessionLifeTime);
  };

  Utils.removeClientSessionIdCookie = function () {
    this.removeCookie(Utils.SESSION_ID_KEY);
  };

  Utils.removeDiveCookies = function () {
    this.removeCookie(Utils.VIEWED_BEFORE_KEY);
    this.removeCookie(Utils.SESSION_ID_KEY);
    this.removeCookie(Utils.PLAYER_ID_KEY);
    this.removeCookie(Utils.GAME_VER_KEY);
    this.removeCookie(Utils.DIVE_CID_KEY);
  };

  Utils.refreshClientSessionId = function (sessionLifeTime) {
    var sessionId = Utils.getCookie(Utils.SESSION_ID_KEY);

    if (!sessionId) {
      this.setClientSessionRestartedFromIdCookie();
      sessionId = Utils.uuidv4();
    }

    this.setCookie(Utils.SESSION_ID_KEY, sessionId, sessionLifeTime);
  };

  Utils.setClientSessionRestartedFromIdCookie = function () {
    var sessionId = Utils.getCookie(Utils.SESSION_ID_KEY);
    if (!sessionId) this.setCookie(Utils.SESSION_RESTARTED_FROM_KEY, sessionId);
  };

  Utils.getClientSessionId = function () {
    return this.getCookie(Utils.SESSION_ID_KEY);
  };

  Utils.getClientSessionRestartedFrom = function () {
    return this.getCookie(Utils.SESSION_RESTARTED_FROM_KEY);
  };

  Utils.inArray = function (p1, p2) {
    return Array.isArray(p1) ? p1.indexOf(p2) !== -1 : Array.isArray(p2) ? p2.indexOf(p1) !== -1 : false;
  };

  Utils.utcToLocal = function (date) {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  };

  Utils.setSettings = function (settings) {
    this.setCookie(Utils.REMOTE_SETTINGS_KEY, JSON.stringify(settings));
  };

  Utils.getSettings = function () {
    var settings = this.getCookie(Utils.REMOTE_SETTINGS_KEY);
    return settings ? JSON.parse(settings) : null;
  };

  Utils.getRemoteConfig = function () {
    var config = this.getCookie(Utils.REMOTE_CONFIG_KEY);
    return config ? JSON.parse(config) : null;
  };

  Utils.setRemoteConfig = function (config) {
    this.setCookie(Utils.REMOTE_CONFIG_KEY, JSON.stringify(config));
  };

  Utils.isIPV4Address = function (text) {
    return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(text);
  };

  Utils.PARAMETER_PREFIX = "dive_";
  Utils.SESSION_ID_KEY = "dive_csid";
  Utils.SESSION_RESTARTED_FROM_KEY = "dive_csrid";
  Utils.VIEWED_BEFORE_KEY = "dive_vbk";
  Utils.DIVE_CID_KEY = "dive_cid";
  Utils.COOKIE_ID_KEY = "COOKIEID";
  Utils.TRACKING_STOPPED_KEY = "tracking_stopped";
  Utils.PLAYER_ID_KEY = "dive_plid";
  Utils.GAME_VER_KEY = "dive_gmv";
  Utils.REMOTE_CONFIG_KEY = "dive_rc";
  Utils.REMOTE_SETTINGS_KEY = "dive_rs";
  Utils.prefabEvents = ["appLaunched", "beacon", "errorCreated", "screenViewed", "sdkStarted"];

  Utils.setCookie = function (name, value, time) {
    if (!Utils.isClient()) return;
    var domain = config_1.default.getInstance().getDomain();
    var cookie;

    if (typeof time !== "undefined") {
      var d = new Date(2147483647 * 1000);

      if (time) {
        d = new Date();
        d.setTime(d.getTime() + time * 1000);
      }

      cookie = name + "=" + value + ";path=/;expires=" + d.toUTCString() + ";domain=" + domain;
    } else {
      cookie = name + "=" + value + ";path=/;domain=" + domain;
    }

    document.cookie = cookie;
  };

  Utils.getCookie = function (name) {
    if (!Utils.isClient()) return;
    var cookie = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return cookie ? cookie[2] : null;
  };

  Utils.removeCookie = function (name) {
    var d = new Date(0);
    document.cookie = name + "=;path=/;expires=" + d.toUTCString() + ";";
  };

  Utils.toISO8601 = function (date) {
    return date.toISOString().split('.')[0] + "Z";
  };

  Utils.isClient = function () {
    return typeof window !== 'undefined' || typeof document !== 'undefined';
  };

  return Utils;
}();

exports.default = Utils;

var WindowStateManager =
/** @class */
function () {
  function WindowStateManager(isNewWindowPromotedToMain, onWindowUpdated) {
    this._LOCALSTORAGE_KEY = 'DIVE_WINDOW_STATE_MANAGER';
    this.RECHECK_WINDOW_DELAY_MS = 100;
    this._initialized = false;
    this._unloaded = false;
    this._isNewWindowPromotedToMain = false; // this.resetWindows();

    this._onWindowUpdated = onWindowUpdated;
    this._isNewWindowPromotedToMain = isNewWindowPromotedToMain;
    this._windowId = Date.now().toString();
    this.bindUnload();
    this.determineWindowState.call(this); // console.log("NEW WINDOW ID", this._windowId);

    this._initialized = true;

    this._onWindowUpdated.call(this);
  }

  WindowStateManager.prototype.determineWindowState = function () {
    var self = this;
    var _previousState = this._isMainWindow;

    if (typeof localStorage !== "undefined") {
      this._windowArray = localStorage.getItem(this._LOCALSTORAGE_KEY);
    }

    if (this._windowArray === null || this._windowArray === "NaN") {
      this._windowArray = [];
    } else {
      if (typeof localStorage !== "undefined") {
        this._windowArray = JSON.parse(this._windowArray);
      } else {
        this._windowArray = [];
      }
    }

    if (this._initialized) {
      if (this._windowArray.length <= 1 || (this._isNewWindowPromotedToMain ? this._windowArray[this._windowArray.length - 1] : this._windowArray[0]) === this._windowId) {
        this._isMainWindow = true;
      } else {
        this._isMainWindow = false;
      }
    } else {
      if (this._windowArray.length === 0) {
        this._isMainWindow = true;
        this._windowArray[0] = this._windowId;

        if (typeof localStorage !== "undefined") {
          localStorage.setItem(this._LOCALSTORAGE_KEY, JSON.stringify(this._windowArray));
        }
      } else {
        this._isMainWindow = false;

        this._windowArray.push(this._windowId);

        if (typeof localStorage !== "undefined") {
          localStorage.setItem(this._LOCALSTORAGE_KEY, JSON.stringify(this._windowArray));
        }
      }
    }

    if (_previousState !== this._isMainWindow) {
      this._onWindowUpdated.call(this);
    }

    setTimeout(function () {
      self.determineWindowState.call(self);
    }, this.RECHECK_WINDOW_DELAY_MS);
  };

  WindowStateManager.prototype.removeWindow = function () {
    if (typeof localStorage !== "undefined") {
      var stored = localStorage.getItem(this._LOCALSTORAGE_KEY);

      if (stored != null) {
        var __windowArray = JSON.parse(stored); // console.log("ARRAY BEFORE:", __windowArray);


        for (var i = 0, length = __windowArray.length; i < length; i++) {
          if (__windowArray[i] === this._windowId) {
            __windowArray.splice(i, 1);

            if (__windowArray.length == 0) {
              Utils.removeDiveCookies();
            }

            this._unloaded = true;
            break;
          }
        } // console.log("ARRAY AFTER:", __windowArray);


        localStorage.setItem(this._LOCALSTORAGE_KEY, JSON.stringify(__windowArray));
      }
    }
  };

  WindowStateManager.prototype.bindUnload = function () {
    var self = this;

    if (typeof window !== "undefined") {
      window.addEventListener('beforeunload', function () {
        if (!self._unloaded) {
          self.removeWindow();
        }
      });
      window.addEventListener('unload', function () {
        if (!self._unloaded) {
          self.removeWindow();
        }
      });
    }
  };

  WindowStateManager.prototype.isMainWindow = function () {
    return this._isMainWindow;
  };

  ;

  WindowStateManager.prototype.resetWindows = function () {
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem(this._LOCALSTORAGE_KEY);
    }
  };

  ;
  return WindowStateManager;
}();

; //@ts-ignore

var windowStateManager = new WindowStateManager(false, windowUpdated);

function windowUpdated() {}